import { Injectable } from '@angular/core';
import { Http, RequestOptions, Response } from "@angular/http";
import 'rxjs/add/operator/map'
import { environment } from "../../environments/environment";
import { Observable } from "rxjs/Observable";
import { Observer } from "rxjs/Observer";

@Injectable()
export class UpdateCacheService {
  public doorswapObservable: Observable<any>;
  public doorswapObserver: Observer<any>;

  private headers: any;
  private options: any;
  private baseUrl: string = environment.apiBaseUrl;

  constructor(private http: Http) { }

  updateEachAndEveryCache(clientCode, propertySoftware) {
    let url: string;
    let body: Object;

    if (propertySoftware == 'sitelink') {
      url = environment.lambdaApi + 'update-cache-each-and-every';
      body = { "clientCode": clientCode, "env": environment.env };
    }

    if (propertySoftware === 'storage-commander') {
      url = this.baseUrl + 'storage-commander/update-cache/each-and-every-cache';
      body = { "clientCode": clientCode };
    }

    if (propertySoftware === 'uhaul') {
      url = environment.lambdaApi + 'uhaul-update-cache';
      body = { "clientCode": clientCode, "env": environment.env };
    }

    this.headers = new Headers({
      "Content-Type": "application/json",
      "Accept": "application/json",
    });
    this.options = new RequestOptions({ headers: this.headers });
    return this.http.post(url, body, this.options).map((res: Response) => res.json());
  }

  updateAllUnitsCache(clientCode, propertySoftware) {
    let url: string;
    let body: Object;

    if (propertySoftware == 'sitelink') {
      url = environment.lambdaApi + 'update-cache-all';
      body = { "clientCode": clientCode, "env": environment.env };
    }

    if (propertySoftware === 'storage-commander') {
      url = this.baseUrl + 'storage-commander/update-cache/units';
      body = { "clientCode": clientCode, "unitFilter": 'All' };
    }

    this.headers = new Headers({
      "Content-Type": "application/json",
      "Accept": "application/json",
    });
    this.options = new RequestOptions({ headers: this.headers });
    return this.http.post(url, body, this.options).map((res: Response) => res.json());
  }

  updateAvailableUnitsCache(clientCode, propertySoftware, updateFbProductSets = false) {
    let url: string;
    let body: Object;
    if (propertySoftware == 'sitelink') {
      url = environment.lambdaApi + 'update-cache-available';
      body = { "clientCode": clientCode, "env": environment.env, "updateFbProductSets": updateFbProductSets };
    }

    if (propertySoftware === 'storage-commander') {
      url = this.baseUrl + 'storage-commander/update-cache/units';
      body = { "clientCode": clientCode, "unitFilter": 'Available' };
    }

    this.headers = new Headers({
      "Content-Type": "application/json",
      "Accept": "application/json",
    });
    this.options = new RequestOptions({ headers: this.headers });
    return this.http.post(url, body, this.options).map((res: Response) => res.json());
  }

  updateInsuranceCache(clientCode, propertySoftware) {
    let url: string;
    if (propertySoftware == 'sitelink')
      url = environment.lambdaApi + 'update-cache-insurance';
    if (propertySoftware === 'storage-commander')
      url = this.baseUrl + 'storage-commander/update-cache/insurance';

    this.headers = new Headers({
      "Content-Type": "application/json",
      "Accept": "application/json",
    });
    this.options = new RequestOptions({ headers: this.headers });
    return this.http.post(url, { "clientCode": clientCode, "env": environment.env }, this.options).map((res: Response) => res.json());
  }

  updateDiscountsCache(clientCode, propertySoftware) {
    let url: string;
    if (propertySoftware == 'sitelink')
      url = environment.lambdaApi + 'update-cache-discounts';
    if (propertySoftware === 'storage-commander')
      url = this.baseUrl + 'storage-commander/update-cache/discounts';

    this.headers = new Headers({
      "Content-Type": "application/json",
      "Accept": "application/json",
    });
    this.options = new RequestOptions({ headers: this.headers });
    return this.http.post(url, { "clientCode": clientCode, "env": environment.env }, this.options).map((res: Response) => res.json());
  }

  deleteAllCacheForALocation(clientCode, locationCode) {
    let url = this.baseUrl + 'sitelink/delete-all-caches-for-location';

    this.headers = new Headers({
      "Content-Type": "application/json",
      "Accept": "application/json",
    });
    this.options = new RequestOptions({ headers: this.headers });
    return this.http.post(url, { "clientCode": clientCode, "locationCode": locationCode }, this.options).map((res: Response) => res.json());
  }


  // /**
  //  *
  //  * Doorswap caches
  //  */
  // async doorswapUpdateDiscountCache(clientCode, locations) {
  //   // var url = this.baseUrl + 'doorswap/discounts-cache';
  //   //
  //   // for(let loc of locations) {
  //   //
  //   //   this.headers = new Headers({
  //   //     "Content-Type": "application/json",
  //   //     "Accept": "application/json",
  //   //   });
  //   //   this.options = new RequestOptions({headers: this.headers});
  //   //   await this.http.post(url, {"clientCode": clientCode, "locationCode": loc}, this.options).map((res: Response) => res.json());
  //   // }
  //   //
  //   //
  //   // return await new Observable(observer => {
  //   //   this.doorswapObserver = observer;
  //   //
  //   //   this.doorswapObserver.next('success');
  //   // });
  //
  //
  //   // return this.doorswapObservable;
  // }
}



// WEBPACK FOOTER //
// ./src/ng2/app/providers/update-cache.service.ts